import { useCallback, useState } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';

// local imports
import { SystemUserService } from 'app/services';
import { useGetSystemUserRolesService } from 'app/hooks/services';
import { useStateCallback } from 'app/hooks';
import { cancelRequests } from 'app/utils/axios';
import { EnvDefaults, FormatUtils, ValidationSchema } from 'app/utils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { SystemUserForm } from 'app/components/organisms/forms';
import { Breadcrumb } from 'app/components/atoms';

const SystemUserAdd = () => {
  const history = useHistory();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useStateCallback(false);

  // stop upload photo and cancel current request
  const removeFile = () => cancelRequests('Request Cancelled!');

  // fetch system user roles
  const { _service } = useGetSystemUserRolesService();
  const systemUserRoles = _service?.data?.roles;

  // submit form
  const handleSubmit = useCallback(
    async values => {
      const { birthdate, telephone, photo, ...rest } = values;
      const valueToUse = {
        ...rest,
        birthdate: FormatUtils.convertPostDate(birthdate),
        telephone: FormatUtils.unFormatPhoneNumber(telephone),
        ...(photo ? { photo } : {})
      };

      setLoading(true, async () => {
        const serviceFn = () => SystemUserService.addSystemUser(valueToUse);
        try {
          await serviceFn();
          setTimeout(() => {
            history.push('/user-management');
          }, 1500);
        } catch (err) {
          console.log('Error -> ', err);
        } finally {
          setLoading(false);
        }
      });
    },
    [setLoading, history]
  );

  return (
    <>
      <FusePageCarded
        header={<Breadcrumb title="Kullanıcı Yönetimi" />}
        contentToolbar={
          <Typography variant="h6" className="m-0 p-24 tracking-wider font-semibold text-gray-800">
            Kullanıcı Ekle
          </Typography>
        }
        content={
          <div className="p-24">
            <Card elevation={4}>
              <CardContent>
                <Formik
                  enableReinitialize
                  initialValues={EnvDefaults.addEditSystemUserDefaults}
                  validationSchema={ValidationSchema.systemUserCrudSchema(false)}
                  onSubmit={handleSubmit}>
                  <Form>
                    <SystemUserForm
                      roles={systemUserRoles}
                      loading={loading}
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      removeFile={removeFile}
                    />
                  </Form>
                </Formik>
              </CardContent>
            </Card>
          </div>
        }
      />
    </>
  );
};

export default SystemUserAdd;
